import React from "react"
import { useSelector } from "react-redux"
import { getUser } from "store/modules/common/auth"
import { Redirect, Route } from "react-router-dom"
import { hasAnyOfRoles } from "utils/user"
import { isWhiteLabelLoginDomain } from "shared"
import { getCleanRedirectUrl } from "utils/url"

/**
 * @type {React.FunctionComponent<import('react-router').RouteProps & {roles?: Array<string>, authFn?: (user: any) => boolean }>}
 */
const PrivateRoute = ({ children = null, roles, authFn, ...rest }) => {
  const user = useSelector(getUser)

  return (
    <Route
      {...rest}
      render={() => {
        const urlParams = new URLSearchParams(window.location.search)
        const redirectLocation = urlParams.get("location")

        if (!user) {
          const redirectUrl = getCleanRedirectUrl()
          if (isWhiteLabelLoginDomain()) {
            return <Redirect to={`/r/login?location=${redirectUrl}`} />
          }
          return <Redirect to={`/react/login?location=${redirectUrl}`} />
        }

        if (
          (roles && !hasAnyOfRoles(user, roles)) ||
          (authFn && !authFn(user))
        ) {
          return <Redirect to="/" />
        }

        if (redirectLocation) {
          window.location.href = redirectLocation
          return null
        }

        return children
      }}
    />
  )
}

export default PrivateRoute
